import { Injectable } from '@angular/core';
import { Color } from 'src/app/libs/proto/commUnity_pb';

@Injectable({
  providedIn: 'root'
})
export class ColorConversionService {

  fgColor(c: number): string {
    switch (c) {
      // Dark Backgrounds -> White Text (#ffffff)
      case Color.COLOR_BLACK:   // black
      case Color.COLOR_BROWN:   // brown
      case Color.COLOR_MAGENTA: // magenta
      case Color.COLOR_PURPLE:  // #7C0AD5
      case Color.COLOR_RED:     // #E30A14
        return '#ffffff';

      // Light & Mid-Bright Backgrounds -> Black Text (#000000)
      case Color.COLOR_BLUE:      // #33FFF0 (Bright Cyan/Blue)
      case Color.COLOR_CYAN:      // cyan
      case Color.COLOR_GOLD:      // #F77006 (Bright Gold/Amber)
      case Color.COLOR_GREEN:     // #29C311 (Vibrant Green)
      case Color.COLOR_GREY:      // grey
      case Color.COLOR_ORANGE:    // #E3560A (Vibrant Orange)
      case Color.COLOR_PINK:      // #F7067E (Vibrant Pink/Magenta)
      case Color.COLOR_SILVER:    // silver
      case Color.COLOR_TURQUOISE: // turquoise
      case Color.COLOR_VIOLET:    // violet
      case Color.COLOR_WHITE:     // white
      case Color.COLOR_YELLOW:    // yellow
      case Color.COLOR_NO:        // transparent
      default:
        return '#000000';
    }
  }
  
  colorhtml(c: number): string {
    switch (c) {
      case Color.COLOR_BLACK:
        return 'black';
      case Color.COLOR_BLUE:
        return '#33FFF0';
      case Color.COLOR_BROWN:
        return 'brown';
      case Color.COLOR_CYAN:
        return 'cyan';
      case Color.COLOR_GOLD:
        return '#F77006';
      case Color.COLOR_GREEN:
        return '#29C311';
      case Color.COLOR_GREY:
        return 'grey';
      case Color.COLOR_MAGENTA:
        return 'magenta';
      case Color.COLOR_ORANGE:
        return '#E3560A';
      case Color.COLOR_PINK:
        return '#F7067E';
      case Color.COLOR_PURPLE:
        return '#7C0AD5';
      case Color.COLOR_RED:
        return '#E30A14';
      case Color.COLOR_SILVER:
        return 'silver';
      case Color.COLOR_TURQUOISE:
        return 'turquoise';
      case Color.COLOR_VIOLET:
        return 'violet';
      case Color.COLOR_WHITE:
        return 'white';
      case Color.COLOR_YELLOW:
        return 'yellow';
      case Color.COLOR_NO:
      default:
        return 'transparent';
    }
  }
}
